export const decodeJWT = (token: string): Record<string, any> => JSON.parse(atob(token.split('.')[1]));
